import { FC } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FlexBox } from '@brg/ui';
import { LoaderSpinner } from 'shared/modals/artzLegalsModal/LoaderAnimation';
import { useFtblProfilePredictions } from 'shared/hooks/useFtblProfilePredictions';
import { ProfilePredictionCard } from './ProfilePredictionCard';
import { PredictionsGrid } from './styles';

type ProfilePredictionsListProps = {
  accountId?: string;
};

export const ProfilePredictionsList: FC<ProfilePredictionsListProps> = ({ accountId }) => {
  const { predictions, isLoading, isLoadingMore, hasMore, loadMore } = useFtblProfilePredictions(accountId);

  if (isLoading) {
    return (
      <FlexBox width="100%" align="center" justify="center" height="200px">
        <LoaderSpinner text="" />
      </FlexBox>
    );
  }

  if (!predictions.length) {
    return null;
  }

  return (
    <InfiniteScroll
      dataLength={predictions.length}
      next={loadMore}
      hasMore={hasMore}
      scrollThreshold={0.9}
      loader={
        isLoadingMore ? (
          <FlexBox width="100%" align="center" justify="center" offsetTop={24} offsetBottom={24}>
            <LoaderSpinner text="" />
          </FlexBox>
        ) : null
      }
    >
      <PredictionsGrid>
        {predictions.map((prediction) => (
          <ProfilePredictionCard key={prediction.id} prediction={prediction} />
        ))}
      </PredictionsGrid>
    </InfiniteScroll>
  );
};
import { FC } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FlexBox } from '@brg/ui';
import { LoaderSpinner } from 'shared/modals/artzLegalsModal/LoaderAnimation';
import { useFtblProfilePredictions } from 'shared/hooks/useFtblProfilePredictions';
import { ProfilePredictionCard } from './ProfilePredictionCard';
import { PredictionsGrid } from './styles';

type ProfilePredictionsListProps = {
  accountId?: string;
};

export const ProfilePredictionsList: FC<ProfilePredictionsListProps> = ({ accountId }) => {
  const { predictions, isLoading, isLoadingMore, hasMore, loadMore } = useFtblProfilePredictions(accountId);

  if (isLoading) {
    return (
      <FlexBox width="100%" align="center" justify="center" height="200px">
        <LoaderSpinner text="" />
      </FlexBox>
    );
  }

  if (!predictions.length) {
    return null;
  }

  return (
    <InfiniteScroll
      dataLength={predictions.length}
      next={loadMore}
      hasMore={hasMore}
      scrollThreshold={0.9}
      loader={
        isLoadingMore ? (
          <FlexBox width="100%" align="center" justify="center" offsetTop={24} offsetBottom={24}>
            <LoaderSpinner text="" />
          </FlexBox>
        ) : null
      }
    >
      <PredictionsGrid>
        {predictions.map((prediction) => (
          <ProfilePredictionCard key={prediction.id} prediction={prediction} />
        ))}
      </PredictionsGrid>
    </InfiniteScroll>
  );
};
